
 



 
 import {fs} from "Config/FsConfig";
 
    import IssueData from 'Modules/Aqs/Scripts/AppServiceContract/IssueData';


    //module PublicIssueAppService {
    class PublicIssueAppService {

    ControllerUrl : string
    Options : JQueryAjaxSettings

    constructor(serverBaseUrl : string = null, controllerPath : string = null, ajaxOptions : JQueryAjaxSettings = null){
        this.ControllerUrl = ((serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : serverBaseUrl) + ((controllerPath == null) ?  "modules/Aqs.AppService/PublicIssueAppService" : controllerPath);
        this.Options = ajaxOptions;
    }

    public Init(options : any = { serverBaseUrl :  null, controllerPath : null, ajaxOptions : null }){
        this.ControllerUrl = ((options.serverBaseUrl == null) ? fs.Config.ServiceBaseUrl : options.serverBaseUrl) + ((options.controllerPath == null) ?  "modules/Aqs.AppService/PublicIssueAppService" : options.controllerPath);
        this.Options = options.ajaxOptions;

        return this;
    }

    
    // post: api/${controller}/
    //public static RouteAdd = () => this.ServiceUrl + `modules/Aqs.AppServiceContract/PublicIssueAppService/Add`;
    public RouteAdd() : string {
        return this.ControllerUrl + "/"+"Add";
    }
    public Add(request: IssueData): JQuery.jqXHR<string> {
        return $.ajax({
                url: this.RouteAdd(),
                contentType: 'application/json; charset=utf-8',
                dataType: "json",
                type: 'post',
                data: JSON.stringify(request),
                async: this.Options == null || this.Options.async == null ? true : this.Options.async
                });
    }                
    
}

export default PublicIssueAppService;



